if(typeof lazySizes === 'undefined'){
	/*! lazysizes - v4.1.8 */
	!function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P-- , (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++ , _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
	/*! ls.rias.min.ks - v4.1.8 */
	!function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = b.aspectratio || b.ratio, g = !b.aspectratio && j.traditionalRatio, h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""), w: d }; c.push(h), c.srcset.push(h.c = h.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; f < d; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j); ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
}

var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
		// Placeholder
		showPlaceholderProductList: true,
		placeholderProductPerRow: 3,
    placeholderProductGridItemClass: 'boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2',
		enableOTP: true,
		separateRefineByFromFilter: true,
		//filterTreeMobileStyle: 'style2', // 'style2', 'style3',
		equal_height: boostPFSThemeConfig.custom.equal_height,
    cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.equal_height_crop_image_position
	},
    selector: {
      otpButtons:'.boost-pfs-filter-product-item-image'
    }
};

(function() {
	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}
	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;


		

		
		console.log(" ==== ProductGridItem ==== ")
		console.log(data.title)
		console.log(data)


		var productTags = data.tags;
		var productTitle = data.title;
		productTitle = productTitle.toLowerCase();
		productTitle ='<span class="boost-product-title">' + productTitle + "</span>";

		// Finds the collection tag
		for (var i = 0; i < productTags.length; i++) {
			var currentTag = productTags[i];
			currentTag = currentTag.toLowerCase();
			if (currentTag.indexOf("collection:") >= 0) {
				currentTag = currentTag.replace("collection:","");
				var collectionTitle = '<span class="boost-collection-title">'  + currentTag + '</span>';
				var productTitle = productTitle.replace(currentTag, "");
				productTitle = "<span class='has-collection-title'>" + collectionTitle + '<span class="boost-product-title">' + productTitle + "</span></span>";
				// console.log(productTitle)
				break
			}
		}

		var itemHtml = "";

		if(window.boostCollectionsContent.foundContent === true) {
			if(window.boostCollectionsContent.itemPositionMobile1 === window.boostCollectionsContent.itemIndex && window.innerWidth < 990 && window.boostCollectionsContent.itemImageMobile1 !== "") {
				if (window.boostCollectionsContent.linkType1 === "popup") {
					var itemHtmlWithFeaturedImage = `<a href="#collection-popup" data-lity class="boost-pfs-filter-product-item--content boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2 hide-desktop"><img src="${ window.boostCollectionsContent.itemImageMobile1 }"></a>`;
					itemHtml += itemHtmlWithFeaturedImage;
				} else {
					var itemHtmlWithFeaturedImage = `<a href="${ window.boostCollectionsContent.link1 }" class="boost-pfs-filter-product-item--content boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2 hide-desktop" data-setting="itemImageMobile1"><img src="${ window.boostCollectionsContent.itemImageMobile1 }"></a>`;
					itemHtml += itemHtmlWithFeaturedImage;
				}
			}

			if(window.boostCollectionsContent.itemPositionDesktop1 === window.boostCollectionsContent.itemIndex && window.innerWidth >= 990  && window.boostCollectionsContent.itemImageDesktop1 !== "") {
				if (window.boostCollectionsContent.linkType1 === "popup") {
					var itemHtmlWithFeaturedImage = `<a href="#collection-popup" data-lity class="boost-pfs-filter-product-item--content boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2 hide-mobile"><img src="${ window.boostCollectionsContent.itemImageDesktop1 }"></a>`;
					itemHtml += itemHtmlWithFeaturedImage;
				} else {
					var itemHtmlWithFeaturedImage = `<a href="${ window.boostCollectionsContent.link1 }" class="boost-pfs-filter-product-item--content boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2 hide-mobile" data-setting="itemImageDesktop1"><img src="${ window.boostCollectionsContent.itemImageDesktop1 }"></a>`;
					itemHtml += itemHtmlWithFeaturedImage;
				}
			}

			if(window.boostCollectionsContent.itemPositionMobile2 === window.boostCollectionsContent.itemIndex && window.innerWidth < 990 && window.boostCollectionsContent.itemImageMobile2 !== "") {
				if (window.boostCollectionsContent.linkType2 === "popup") {
					var itemHtmlWithFeaturedImage = `<a href="#collection-popup" data-lity class="boost-pfs-filter-product-item--content boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2 hide-desktop"><img src="${ window.boostCollectionsContent.itemImageMobile2 }"></a>`;
					itemHtml += itemHtmlWithFeaturedImage;
				} else {
					var itemHtmlWithFeaturedImage = `<a href="${ window.boostCollectionsContent.link2 }" class="boost-pfs-filter-product-item--content boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2 hide-desktop" data-setting="itemImageMobile2"><img src="${ window.boostCollectionsContent.itemImageMobile2 }"></a>`;
					itemHtml += itemHtmlWithFeaturedImage;
				}
			}

			if(window.boostCollectionsContent.itemPositionDesktop2 === window.boostCollectionsContent.itemIndex && window.innerWidth >= 990 && window.boostCollectionsContent.itemImageDesktop2 !== "") {
				if (window.boostCollectionsContent.linkType2 === "popup") {
					var itemHtmlWithFeaturedImage = `<a href="#collection-popup" data-lity class="boost-pfs-filter-product-item--content boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2 hide-mobile"><img src="${ window.boostCollectionsContent.itemImageDesktop2 }"></a>`;
					itemHtml += itemHtmlWithFeaturedImage;
				} else {
					var itemHtmlWithFeaturedImage = `<a href="${ window.boostCollectionsContent.link2 }" class="boost-pfs-filter-product-item--content boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2 hide-mobile" data-setting="itemImageDesktop2"><img src="${ window.boostCollectionsContent.itemImageDesktop2 }"></a>`;
					itemHtml += itemHtmlWithFeaturedImage;
				}
			}

			if(window.boostCollectionsContent.itemPositionMobile3 === window.boostCollectionsContent.itemIndex && window.innerWidth < 990 && window.boostCollectionsContent.itemImageMobile3 !== "") {
				if (window.boostCollectionsContent.linkType3 === "popup") {
					var itemHtmlWithFeaturedImage = `<a href="#collection-popup" data-lity class="boost-pfs-filter-product-item--content boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2 hide-desktop"><img src="${ window.boostCollectionsContent.itemImageMobile2 }"></a>`;
					itemHtml += itemHtmlWithFeaturedImage;
				} else {
					var itemHtmlWithFeaturedImage = `<a href="${ window.boostCollectionsContent.link3 }" class="boost-pfs-filter-product-item--content boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2 hide-desktop" data-setting="itemImageMobile2"><img src="${ window.boostCollectionsContent.itemImageMobile2 }"></a>`;
					itemHtml += itemHtmlWithFeaturedImage;
				}
			}

			if(window.boostCollectionsContent.itemPositionDesktop3 === window.boostCollectionsContent.itemIndex && window.innerWidth >= 990 && window.boostCollectionsContent.itemImageDesktop3 !== "") {
				if (window.boostCollectionsContent.linkType3 === "popup") {
					var itemHtmlWithFeaturedImage = `<a href="#collection-popup" data-lity class="boost-pfs-filter-product-item--content boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2 hide-mobile"><img src="${ window.boostCollectionsContent.itemImageDesktop3 }"></a>`;
					itemHtml += itemHtmlWithFeaturedImage;
				} else {
					var itemHtmlWithFeaturedImage = `<a href="${ window.boostCollectionsContent.link3 }" class="boost-pfs-filter-product-item--content boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2 hide-mobile" data-setting="itemImageDesktop3"><img src="${ window.boostCollectionsContent.itemImageDesktop3 }"></a>`;
					itemHtml += itemHtmlWithFeaturedImage;
				}
			}

			if(window.boostCollectionsContent.itemPositionMobile4 === window.boostCollectionsContent.itemIndex && window.innerWidth < 990 && window.boostCollectionsContent.itemImageMobile4 !== "") {
				if (window.boostCollectionsContent.linkType4 === "popup") {
					var itemHtmlWithFeaturedImage = `<a href="#collection-popup" data-lity class="boost-pfs-filter-product-item--content boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2 hide-desktop"><img src="${ window.boostCollectionsContent.itemImageMobile4 }"></a>`;
					itemHtml += itemHtmlWithFeaturedImage;
				} else {
					var itemHtmlWithFeaturedImage = `<a href="${ window.boostCollectionsContent.link3 }" class="boost-pfs-filter-product-item--content boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2 hide-desktop" data-setting="itemImageMobile4"><img src="${ window.boostCollectionsContent.itemImageMobile4 }"></a>`;
					itemHtml += itemHtmlWithFeaturedImage;
				}
			}

			if(window.boostCollectionsContent.itemPositionDesktop4 === window.boostCollectionsContent.itemIndex && window.innerWidth >= 990  && window.boostCollectionsContent.itemImageDesktop4 !== "") {
				if (window.boostCollectionsContent.linkType4 === "popup") {
					var itemHtmlWithFeaturedImage = `<a href="#collection-popup" data-lity class="boost-pfs-filter-product-item--content boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2 hide-mobile"><img src="${ window.boostCollectionsContent.itemImageDesktop4 }"></a>`;
					itemHtml += itemHtmlWithFeaturedImage;
				} else {
					var itemHtmlWithFeaturedImage = `<a href="${ window.boostCollectionsContent.link4 }" class="boost-pfs-filter-product-item--content boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2 hide-mobile" data-setting="itemImageDesktop4"><img src="${ window.boostCollectionsContent.itemImageDesktop4 }"></a>`;
					itemHtml += itemHtmlWithFeaturedImage;
				}
			}

			
		}


		// Get Template
		itemHtml += boostPFSTemplate.productGridItemHtml;



		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
		// Add Grid Width class
		itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));

		// Add Grid Width class
		itemHtml = itemHtml.replace(/{{itemGridProductTitle}}/g, buildItemGridProductTitle(data));

		// Add Label
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
		// Add TAG Label
		itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, true));

		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
		// itemActiveSwapClass
		var itemActiveSwapClass = boostPFSThemeConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
		itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
		// Add Color Swatches
  		itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));

		// Add data json
			itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));

		/* Swym integration */
		var itemWishlistHtml = '<button class="swym-button swym-add-to-wishlist-view-product product_{{itemId}}" data-swaction="addToWishlist"  data-product-id="' + JSON.stringify(data.id) + '"></button>';
		itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, productTitle);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));


	

		window.boostCollectionsContent.itemIndex += 1;


		return itemHtml;
	};
	// Build Product List Item
	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		// For List View
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/
		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
		// Add Label
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
		// Add TAG Label
		itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, true));
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
		// Description
		var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
		itemDescription = (itemDescription.split(" ")).length > 35 ? itemDescription.split(" ").splice(0, 35).join(" ") + '...' : itemDescription.split(" ").splice(0, 35).join(" ");
		itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
		// itemActiveSwapClass
		var itemActiveSwapClass = boostPFSThemeConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
		itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
		// Add Color Swatches
  		itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		return itemHtml;
		// End For List View
	};
	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildGridWidthClass() {
		var gridWidthClass = '';
		// On PC
		switch (boostPFSThemeConfig.custom.products_per_row) {
			case 2:
				gridWidthClass = 'boost-pfs-filter-grid-width-2';
				break;
			case 3:
				gridWidthClass = 'boost-pfs-filter-grid-width-3';
				break;
			case 5:
				gridWidthClass = 'boost-pfs-filter-grid-width-5';
				break;
			default:
				gridWidthClass = 'boost-pfs-filter-grid-width-4';
				break;
		}
		// On Mobile
		switch (boostPFSThemeConfig.custom.products_per_row_mobile) {
			case 1:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-1';
				break;
			case 3:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-3';
				break;
			default:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-2';
				break;
		}
		return gridWidthClass;
	}

	function buildItemGridProductTitle(data) {
		var html = '';

		html = data.title;

		return html;
	}

	function buildImages(data) {
	  var html = '';
    var aspect_ratio = '';
	  // Build Main Image
	  var thumbUrl = Utils.getFeaturedImage(images, '260x');
      var flipImageSrc = images.length > 1 ? Utils.optimizeImage(images[1]['src'],'300x') : Utils.getFeaturedImage(images, '300x');
      var flipImageSrcset = images.length > 1 ? Utils.optimizeImage(images[1]['src'], '270x') + " " + '270w' + ', ' + Utils.optimizeImage(images[1]['src'], '390x') + " " + '390w' + ', ' + Utils.optimizeImage(images[1]['src'], '540x') + " " + '540w' : Utils.getFeaturedImage(images, '270x') + " " + '270w' + ', ' + Utils.getFeaturedImage(images, '390x') + " " + '390w' + ', ' + Utils.getFeaturedImage(images, '540x') + " " + '540w' + ', ' + Utils.getFeaturedImage(images, '720x') + " " + '720w';
      html += '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-image-link" style="padding-top:';
		if (images.length > 0) {
		aspect_ratio = images[0]['width'] / images[0]['height'];
		html += 1 / aspect_ratio * 100;
		} else {
			html += 100;
		}
		html += '%;">';
      	html += '<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"' +
		  'data-srcset="' + Utils.getFeaturedImage(images, '270x') + " " + '270w' + ', ' + Utils.getFeaturedImage(images, '390x') + " " + '390w' + ', ' + Utils.getFeaturedImage(images, '540x') + " " + '540w' + ', ' + Utils.getFeaturedImage(images, '720x') + " " + '720w' + '" ' +
		  'data-src="' + thumbUrl + '" ' +
		  'data-widths="[270, 390, 540, 720]" ' +
		  'data-sizes="auto" ' +
		  'src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" ' +
		  'alt="' + data.title + '" />';

				html += '<img class="boost-pfs-filter-product-item-second-image lazyload Image--lazyLoad"' +
			'data-srcset="' + flipImageSrcset + '" ' +
			'data-src="' + flipImageSrc + '" ' +
			'data-widths="[270, 390, 540, 720]" ' +
			'data-sizes="auto" ' +
			'src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" ' +
			'alt="' + data.title + '" />';

        html += '</a>';

				if (window.theme.enable_collection_videos) {
					if (data.metafields[0]) {
						if (data.metafields[0].key === "collection_video") {
							var videoURL = data.metafields[0].value;

							if (videoURL.length > 0) {

								html += '<div className="product-card__hide-video" onClick="stopCollectionVideo(' + data.id + ')">';
	              html += '<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">';
	              html += '<circle opacity="0.5" cx="17.5" cy="17.5" r="17.5" fill="#1D1D1F" fill-opacity="0.5"/>';
	              html += '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.95707 9L9.00001 9.95707L16.4173 17.3744L9 24.7917L9.95707 25.7487L17.3744 18.3314L24.7916 25.7487L25.7487 24.7916L18.3314 17.3744L25.7487 9.9571L24.7916 9.00003L17.3744 16.4173L9.95707 9Z" fill="#F4F4F4"/>';
	              html += '</svg>';
	              html +=	'</div>';

								html += '<div className="product-card__show-video" onClick="playCollectionVideo(' + data.id + ')">'
	              html += '<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">'
	              html += '<circle opacity="0.5" cx="17.5" cy="17.5" r="17.5" fill="#1D1D1F" fill-opacity="0.5"/>'
	              html += '<path d="M25.9678 17.5L12.4194 25.9677L12.4194 9.03226L25.9678 17.5Z" fill="#F4F4F4"/>'
	              html += '</svg>'
	            	html += '</div>'

								html += '<video class="product-item--collection-video product-item--collection-video-' + data.id + '" src=' + videoURL + ' type="video/mp4" width="500" height="500" playsinline="true" webkit-playsinline loop="true" muted="true" poster="https://cdn.shopify.com/s/files/1/0146/8461/8806/files/Rolling-1s-500px.gif?v=1654050817"></video>';
							}

						}
					}
				}

				// console.log("----")
				// console.log(data.title)
				// console.log(data)


	  return html;
  }

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.show_vendor) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildPrice(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.show_price) {
			var saleRedTag = false;
			var productTags = data.tags;
			for (var i = 0; i < productTags.length; i++) {
				var currentTag = productTags[i];
				if (currentTag.indexOf("SALE RED") >= 0) {
						var saleRedTag = true;
				}
			}

			var promoPrice = null;
			var percentOff = null;
			for (var i = 0; i < productTags.length; i++) {
				var currentTag = productTags[i];
				if (currentTag.indexOf("sale10") >= 0 || currentTag.indexOf("sale20") >= 0 || currentTag.indexOf("sale30") >= 0 || currentTag.indexOf("sale40") >= 0 || currentTag.indexOf("sale50") >= 0 || currentTag.indexOf("sale60") >= 0) {
					currentTag = currentTag.replace("sale","");
					percentOff = currentTag;
					promoPrice = data.price_min * (100 - currentTag) / 100
					break
				}
			}

			var showSaleMessage = false;

			if(window.sale.show_sale_message === true) {
				for (var i = 0; i < productTags.length; i++) {
					var currentTag = productTags[i];
					if (currentTag === window.sale.sale_message_tag) {
						showSaleMessage = true;
						break
					}
				}
			}
			console.log("showSaleMessage")
			console.log(showSaleMessage)

			var showPromoPrice = false;
			if (window.theme.product_tag_sale_customers_only && window.theme.enable_product_tag_sale) {
				if (window.theme.customer) {
					showPromoPrice = true
				} else {
					showPromoPrice = true
				}
			} else if (window.theme.enable_product_tag_sale) {
				showPromoPrice = true
			}


				if (saleRedTag === true) {
					html = `<p class="boost-pfs-filter-product-item-price sale-red-price ${showSaleMessage ? "show-sale-message": ""}">`;
				} else {
					html = `<p class="boost-pfs-filter-product-item-price ${showSaleMessage ? "show-sale-message": ""}">`;
				}

				if (promoPrice !== null && showPromoPrice) {
					html += '<span class="boost-pfs-filter-product-item-sale-price">' + (Utils.formatMoney(promoPrice)).replace(".00","").replace(",00","") + '</span>';
					html += '<s>' + (Utils.formatMoney(data.price_min)).replace(".00","").replace(",00","") + '</s> ';
					html += '<p class="product-tag-sale--label">' + percentOff + '% OFF</p>';
				} else {
					if (onSale) {
						html += '<span class="boost-pfs-filter-product-item-sale-price">' + (Utils.formatMoney(data.price_min)).replace(".00","").replace(",00","") + '</span>';
						html += '<s>' + (Utils.formatMoney(data.compare_at_price_min)).replace(".00","").replace(",00","") + '</s> ';
					} else {
						if (priceVaries) {
							html += '<span class="boost-pfs-filter-product-item-price-from-text">' + (boostPFSThemeConfig.label_basic.from) + ' '+ '</span>';
						}
						html += '<span class="boost-pfs-filter-product-item-regular-price">' + (Utils.formatMoney(data.price_min)).replace(".00","").replace(",00","") + '</span>';
					}
			}
			html += '</p>';
		}

		

		if ((data.title).indexOf("Emily") >= 0 || (data.title).indexOf("Nakeds") >= 0) {
			var selectedColour = null;

			if((data.title).indexOf("Almond") >= 0) {
				selectedColour = "selected-almond";
			} else if((data.title).indexOf("Toffee") >= 0) {
				selectedColour = "selected-toffee";
			} else if((data.title).indexOf("Mahogany") >= 0) {
				selectedColour = "selected-mahogany";
			} else if((data.title).indexOf("Nero") >= 0) {
				selectedColour = "selected-nero";
			} else if((data.title).indexOf("Maple") >= 0) {
				selectedColour = "selected-maple";
			} else if((data.title).indexOf("Honeysuckle") >= 0) {
				selectedColour = "selected-honeysuckle";
			} else if((data.title).indexOf("Cedar") >= 0) {
				selectedColour = "selected-cedar";
			} else if((data.title).indexOf("Rosewood") >= 0) {
				selectedColour = "selected-rosewood";
			} else if((data.title).indexOf("Chestnut") >= 0) {
				selectedColour = "selected-chestnut";
			}

			html += "<div class='collection-nakeds-swatches'>";


				if(data.product_type === "Hosiery") {
					html += `<div class='swatch-maple ${ selectedColour }'></div>`;
					html += `<div class='swatch-honeysuckle ${ selectedColour }'></div>`;
					html += `<div class='swatch-cedar ${ selectedColour }'></div>`;
					html += `<div class='swatch-rosewood ${ selectedColour }'></div>`;
					html += `<div class='swatch-chestnut ${ selectedColour }'></div>`;
					html += `<div class='swatch-mahogany ${ selectedColour }'></div>`;
				} else {

					if((data.title).indexOf("Nakeds") >= 0) {
						html += `<div class='swatch-almond ${ selectedColour }'></div>`;
					}
					html += `<div class='swatch-toffee ${ selectedColour }'></div>`;
					html += `<div class='swatch-mahogany ${ selectedColour }'></div>`;
					html += `<div class='swatch-nero ${ selectedColour }'></div>`;
				}

			
			html += "</div>";
		}


		if ((data.title).indexOf("Smooths") >= 0 && data.product_type !== "Dress") {
			var selectedColour = null;

			if((data.title).indexOf("Almond") >= 0) {
				selectedColour = "selected-almond";
			} else if((data.title).indexOf("Ivory") >= 0) {
				selectedColour = "selected-ivory";
			} else if((data.title).indexOf("Leopard") >= 0) {
				selectedColour = "selected-leopard";
			} else if((data.title).indexOf("Nero") >= 0) {
				selectedColour = "selected-nero";
			}

			html += "<div class='collection-smooths-swatches'>";
			html += `<div class='swatch-ivory ${ selectedColour }'></div>`;
			html += `<div class='swatch-almond ${ selectedColour }'></div>`;
			html += `<div class='swatch-leopard ${ selectedColour }'></div>`;
			html += `<div class='swatch-nero ${ selectedColour }'></div>`;
			html += "</div>";
		}


		if ((data.title).indexOf("Essentials") >= 0) {
			var selectedColour = null;

			if((data.title).indexOf("Baby Blue") >= 0 || (data.title).indexOf("Candy Pink") >= 0 || (data.title).indexOf("Magenta") >= 0 || (data.title).indexOf("Rainbow") >= 0) {

				if((data.title).indexOf("Baby Blue") >= 0) {
					selectedColour = "selected-baby-blue";
				} else if((data.title).indexOf("Candy Pink") >= 0) {
					selectedColour = "selected-candy-pink";
				} else if((data.title).indexOf("Magenta") >= 0) {
					selectedColour = "selected-magenta";
				} else if((data.title).indexOf("Rainbow") >= 0) {
					selectedColour = "selected-rainbow";
				}
	
				html += "<div class='collection-essentials-swatches'>";
				html += `<div class='swatch-baby-blue ${ selectedColour }'></div>`;
				html += `<div class='swatch-candy-pink ${ selectedColour }'></div>`;
				html += `<div class='swatch-magenta ${ selectedColour }'></div>`;
				html += `<div class='swatch-rainbow ${ selectedColour }'></div>`;
				html += "</div>";

			} else {


				if((data.title).indexOf("Green") >= 0) {
					selectedColour = "selected-green";
				} else if((data.title).indexOf("Orange") >= 0) {
					selectedColour = "selected-orange";
				} else if((data.title).indexOf("Purple") >= 0) {
					selectedColour = "selected-purple";
				} else if((data.title).indexOf("Black") >= 0) {
					selectedColour = "selected-black";
				}
	
				html += "<div class='collection-essentials-swatches'>";
				html += `<div class='swatch-black ${ selectedColour }'></div>`;

				if(data.product_type !== "Corset") {
					html += `<div class='swatch-orange ${ selectedColour }'></div>`;
					html += `<div class='swatch-green ${ selectedColour }'></div>`;
				}

				html += `<div class='swatch-purple ${ selectedColour }'></div>`;
				html += "</div>";
			}
	


		}


		if(showSaleMessage){
			html += `<div class="collection-item--sale-message">${window.sale.sale_message}</div>`;
		}

		if (data.available === true && data.product_type !== "Lingerie Set") {
			// console.log('true')

			var quickAddHTML = '<div class="collections-quick-add">';

			var dataBIS = {
				"id": data.id,
				"handle": data.handle,
				"tags": [],
				"available": false,
				"variants": []
			}

			if (data.variants.length) {
			for( var i = 0; i < data.variants.length; i++){
				var variantData = data.variants[i];
				if(variantData.available === false){
					dataBIS.variants.push({"id":variantData.id,"title":variantData.title,"available":false,"inventory_quantity":0,"inventory_management":"shopify"});
				}
		
			  };
			}

			// console.log(data)
			//Chemise, Teddy, Cami, Pants, Shorts
			for( var i = 0; i < data.variants.length; i++){
     			if (data.variants[i]) {
					if (data.product_type === "Top" || data.product_type === "Skirt" || data.product_type === "Corset" || data.product_type === "Dress" || data.product_type === "Mask" || data.product_type === "Game" || data.product_type === "Pants" || data.product_type === "Head Chain" || data.product_type === "Bag" || data.product_type === "Harness" || data.product_type === "Bralette" || data.product_type === "Tops" || data.product_type === "Pants" || data.product_type === "Shorts" || data.product_type === "Cami" || data.product_type === "Chemise" || data.product_type === "Teddy" || data.product_type === "Toys" || data.product_type === "Candles" || data.product_type === "Bondage" || data.product_type === "Lubricants" || data.product_type === "Accessories" || data.product_type === "Latex" || data.product_type === "Robe" || data.product_type === "novelty" || data.product_type === "Hosiery" || data.product_type === "Toy" || data.product_type === "Novelty" || data.product_type === "Lubricant" || data.product_type === "Gloves" || data.product_type === "Thong" || data.product_type === "Brief" || data.product_type === "Bodysuit" || data.product_type === "Suspender" || data.product_type === "Candle" || data.product_type === "Hoisery" || data.product_type === "Swimwear") {

					if (data.template_suffix !== "bundle" && data.variants.length < 10) {
						var variantData = data.variants[i];

						var item = {
							id: variantData.id,
							product_id: data.id,
							quantity: 1,
							price: variantData.price,
							compare_at_price: variantData.compare_at_price,
							title: data.title,
							url: '/products/' + data.handle,
							image: data.images[1],
							product_type: data.product_type,
							handle: data.handle,
							min: 0,
							max: 999,
							final_sale: false,
							new_to_sale: false,
							further_markdowns: false
						};

						if(window.sale.final_sale){
							var productTags = data.tags;
							for (var k = 0; k < productTags.length; k++) {
								var currentTag = productTags[k];
								if (currentTag.indexOf("Final Sale") >= 0) {
									item.final_sale = true;
									break;
								}
							}
						}

						if(window.sale.new_to_sale){
							var productTags = data.tags;
							for (var k = 0; k < productTags.length; k++) {
								var currentTag = productTags[k];
								if (currentTag.indexOf("MSS-25") >= 0) {
									item.new_to_sale = true;
									break;
								}
							}
						}

						if(window.sale.further_markdowns){
							var productTags = data.tags;
							for (var k = 0; k < productTags.length; k++) {
								var currentTag = productTags[k];
								if (currentTag.indexOf("MSS-25-FURTHERS") >= 0) {
									item.further_markdowns = true;
									break;
								}
							}
						}
					
						item = JSON.stringify(JSON.stringify(item));
						// console.log("variantData")
						item = item.replace(/"/g,"'");
						// console.log("variantData")
						// console.log(item)
						// console.log(variantData)
						// variantData = "'" + variantData + "'";

						
						let safeDataBIS = JSON.stringify(dataBIS).replace(/"/g, '&quot;');
				
					
						if (data.variants.length === 1) {
							if(data.variants[i].available === true) {
								quickAddHTML += `<button aria-label="${window.theme.locales.addToCart}" class="btn btn--secondary collections-quick-add-button" onclick="quickAddFromCollections(${ item })">${window.theme.locales.addToCart}</button>`;
							} else {
								// quickAddHTML += `<button class="btn btn--secondary collections-quick-add-button" disabled onclick="quickAddFromCollections(${ item })">ADD TO BAG</button>`;								
								quickAddHTML += `<button href="#" aria-label="{{ variant.title }}" class="BIS_trigger btn btn--secondary collections-quick-add-button disabled" data-product-data="${safeDataBIS}">{{ variant.title }}</button>`;
							}

						} else {

							if(data.variants[i].available === true) {
							 quickAddHTML += `<button aria-label="${variantData.title}" class="btn btn--secondary collections-quick-add-button" onclick="quickAddFromCollections(${ item })">${ variantData.title }<small>ADD TO BAG</small></button>`;
							} else {
							//  quickAddHTML += `<button class="btn btn--secondary collections-quick-add-button" disabled onclick="quickAddFromCollections(${ item })">${ data.variants[i].title }<small>ADD TO BAG</small></button>`;
								quickAddHTML += `<button aria-label="NOTIFY ME" href="#" class="BIS_trigger btn btn--secondary collections-quick-add-button disabled" data-product-data='${ safeDataBIS }'  data-variant-id="${variantData.id }">${ variantData.title }<small>NOTIFY ME</small></button>`;
							}
						}
					} else if (data.template_suffix !== "bundle" && data.variants.length >= 10) {
						quickAddHTML += `<a aria-label="${window.theme.locales.selectSize}" href="/products/${ data.handle }" class="btn btn--secondary collections-quick-add-button">${window.theme.locales.selectSize}</a>`;
						break;
					}
				} 
	    	}
	    }

		if (data.product_type === "Bra"  || data.product_type === "Bustier" || data.product_type === "Essentials") {
			var quickAddHTML = '<div class="collections-quick-add">';

			if(data.available === true ) {
				// quickAddHTML += `<button class="btn btn--secondary collections-quick-add-button quick-add-button--1" onclick="quickAddFromCollectionsPopup('${data.handle}')">SELECT SIZE</button>`;
				// quickAddHTML += `<button class="btn btn--secondary collections-quick-add-button quick-add-button--2" onclick="quickAddFromCollectionsPopup('${data.handle}')">SHOP SIZES</button>`;
				quickAddHTML += `<a aria-label="${window.theme.locales.selectSize}"  href="/products/${ data.handle }" class="btn btn--secondary collections-quick-add-button">${window.theme.locales.selectSize}</a>`;
			}

		}

			quickAddHTML += '</div>'
			html += quickAddHTML;
		}




		if (data.product_type === "Lingerie Set") {
			var quickAddHTML = '<div class="collections-quick-add">';
			quickAddHTML += `<a aria-label="${window.theme.locales.selectSize}"  href="/products/${ data.handle }" class="btn btn--secondary collections-quick-add-button">${window.theme.locales.selectSize}</a>`;
			quickAddHTML += '</div>'
			html += quickAddHTML;
		}




	



		return html;
	}

	function buildLabels(data) {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.show_sold_out_label && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
		}
		// Build Sale label
		var saleLabel = '';
		if (boostPFSThemeConfig.custom.show_sale_label && onSale && !soldOut) {
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '');
		}
		// Build Labels
		return soldOutLabel + saleLabel;
	}




	// BUILD LABEL PRODUCT WITH TAGS
	function buildTagLabels(data, showall) {
		if (showall) {

			// console.log("hererere")

			var tagLabel = '';

			// console.log(data)
			// console.log(data.price)
			// console.log(data.compare_at_price)

			if (data.percent_sale_min > 0) {

				var percentOff = data.percent_sale_min;
				var percentOffString = percentOff.toString().split("");

				var firstNumber = Number(percentOffString[0]);
				var lastNumber = Number(percentOffString[1]);
				var endNumber = 0;

				if (lastNumber >= 4 && lastNumber <= 7) {
					endNumber = 5;
				} else if (lastNumber >= 1 && lastNumber <= 3) {
					endNumber = 0;
				} else if (lastNumber >= 8) {
					endNumber = 0;
					firstNumber = firstNumber + 1;
				} else {
					endNumber = 0;
				}

				var finalSale = false;
				if(window.sale.final_sale) {
					for (var i = 0; i < data.tags.length; i++) {
						var tag = data.tags[i];
						if (tag.indexOf("Final Sale") >= 0) {
							finalSale = true;
							break;
						}
					}
				}
				var newToSale = false;
				if(window.sale.new_to_sale) {
					for (var i = 0; i < data.tags.length; i++) {
						var tag = data.tags[i];
						if (tag.indexOf("MSS-25") >= 0) {
							newToSale = true;
							break;
						}
					}
				}
				
				var furtherMarkdowns = false;
				if(window.sale.further_markdowns) {
					for (var i = 0; i < data.tags.length; i++) {
						var tag = data.tags[i];
						if (tag.indexOf("MSS-25-FURTHER") >= 0) {
							furtherMarkdowns = true;
							break;
						}
					}
				}

				var flashSale = false;
				if(window.sale.flash_sale) {
					for (var i = 0; i < data.tags.length; i++) {
						var tag = data.tags[i];
						if (tag.indexOf("Flash Sale") >= 0) {
							flashSale = true;
							break;
						}
					}
				}

				var combinedNumber = firstNumber + "" + endNumber;

				if (flashSale) {

					if(window.theme.selectedLang === "FR") {
						var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, combinedNumber + "% OFF | SOLDES EXCLUSIVES");
					} else if (window.theme.selectedLang === "DE") {
						var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, combinedNumber + "% OFF | FLASH-SALE");
					} else {
						var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, combinedNumber + "% OFF | FLASH SALE");
					}

					boostPFSTemplate.tagLabelHtml.replace(/{{labelTagClass}}/g, combinedNumber + "% OFF | SALE");
					tagLabel += preTagLabel;
				} else if (finalSale) {

					if(window.theme.selectedLang === "FR") {
						var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, combinedNumber + "% OFF | VENTE FINALE");
					} else if (window.theme.selectedLang === "DE") {
						var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, combinedNumber + "% OFF | Schlussverkauf");
					} else {
						var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, combinedNumber + "% OFF | FINAL SALE");
					}

					boostPFSTemplate.tagLabelHtml.replace(/{{labelTagClass}}/g, combinedNumber + "% OFF | SALE");
					tagLabel += preTagLabel;

				} else if (newToSale) {

				if (window.theme.selectedLang === "FR") {
					var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, combinedNumber + "% OFF | NOUVEAUTÉ EN SOLDE");
				} else if (window.theme.selectedLang === "DE") {
					var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, combinedNumber + "% OFF | NEU IM SALE");
				} else {
					var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, combinedNumber + "% OFF | NEW TO SALE");
				}

					boostPFSTemplate.tagLabelHtml.replace(/{{labelTagClass}}/g, combinedNumber + "% OFF | SALE");
					tagLabel += preTagLabel;
				} else if (furtherMarkdowns) {

					if (window.theme.selectedLang === "FR") {
						var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, combinedNumber + "% OFF | RÉDUCTION SUPPLÉMENTAIRE");
					} else if (window.theme.selectedLang === "DE") {
						var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, combinedNumber + "% OFF | WEITERE REDUZIERUNG");
					} else {
						var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, combinedNumber + "% OFF | FURTHER MARKDOWN");
					}

					boostPFSTemplate.tagLabelHtml.replace(/{{labelTagClass}}/g, combinedNumber + "% OFF | SALE");
					tagLabel += preTagLabel;
				} else {
					var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, combinedNumber + "% OFF");
					boostPFSTemplate.tagLabelHtml.replace(/{{labelTagClass}}/g, combinedNumber + "% OFF");
					tagLabel += preTagLabel;
				}


				for (var i = 0; i < data.tags.length; i++) {
					var tag = data.tags[i];
					if (tag.indexOf("promo-title:") !== -1 || tag.indexOf("Promo-title:") !== -1) {

						if (tag.indexOf("|") > 0 && window.theme.region === "EU") {
							console.log('true')
							console.log(tag)

							var splitTag = tag.replace("promo-title:","").replace("Promo-title:","").split("|");
							console.log(splitTag)

							if (window.theme.selectedLang == "FR") {
								tag = "promo-title:" + splitTag[1];
							} else if (window.theme.selectedLang == "DE") {
								tag = "promo-title:" + splitTag[2];
							} else {
								tag = "promo-title:" + splitTag[0];
							}
						}

						var preTagLabel2 = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('promo-title:')[1]);
						boostPFSTemplate.tagLabelHtml.replace(/{{labelTagClass}}/g, tag.split('promo-title:')[1]);
						tagLabel += preTagLabel2;
					}
				}

			} else if (data.tags) {
					for (var i = 0; i < data.tags.length; i++) {
						var tag = data.tags[i];
						if (tag.indexOf("promo-title:") !== -1 || tag.indexOf("Promo-title:") !== -1) {

							if (tag.indexOf("|") > 0 && window.theme.region === "EU") {
								console.log('true')
								console.log(tag)

								var splitTag = tag.replace("promo-title:","").replace("Promo-title:","").split("|");
								console.log(splitTag)

								if (window.theme.selectedLang == "FR") {
									tag = "promo-title:" + splitTag[1];
								} else if (window.theme.selectedLang == "DE") {
									tag = "promo-title:" + splitTag[2];
								} else {
									tag = "promo-title:" + splitTag[0];
								}
							}

							var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('promo-title:')[1]);
							boostPFSTemplate.tagLabelHtml.replace(/{{labelTagClass}}/g, tag.split('promo-title:')[1]);
							tagLabel += preTagLabel;
						}
					}
			}
		} else {
			var tagLabel = '';
			if (data.percent_sale_min > 0) {

					console.log("test2")

				var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, data.percent_sale_min + "% OFF");
				boostPFSTemplate.tagLabelHtml.replace(/{{labelTagClass}}/g, data.percent_sale_min + "% OFF");
				tagLabel += preTagLabel;

			} else if (data.tags) {
				for (var i = data.tags.length - 1; i >= 0; i--) {
					tag = data.tags[i];
					if (tag.indexOf("promo-title:") !== -1) {
						var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('promo-title:')[1]);
						boostPFSTemplate.tagLabelHtml.replace(/{{labelTagClass}}/g, tag.split('promo-title:')[1]);
						tagLabel += preTagLabel;
						break;
					}
				}
			}
		}
		return tagLabel;
	}

	// Build Color Swatches
	function buildColorSwatches(data) {
		var colorSwatchesHtml = '';
		if (boostPFSThemeConfig.custom.display_item_swatch) {
			colorSwatchesHtml += '<ul class="boost-pfs-filter-item-swatch">';
			for (var index = 0; index < data.options.length; index++) {
				var option = data['options'][index].toLowerCase();
				if (option == 'color') {
					var colorlist = '';
					var color = '';
					var totalVariants = 0;
					for (var k = 0; k < data.variants.length; k++) {
						var variant = data['variants'][k];
						color = variant['options'][index];
						if (colorlist.indexOf(color) == -1) {
							if (totalVariants < 4) {
								var text = Utils.slugify(color);
								var border = text == 'white' ? 'border: 1px solid #cbcbcb;' : '';
								var backgroundImage = Utils.optimizeImage(variant.image, '24x');
								var backgroundImageURL = '';
								var dataImg = '';
								var dataColor = '#fff';
								dataColors = variant.option_color.toLowerCase().split(' ');
								var i = dataColors.length - 1;
								if (dataColors[i] !== '' && dataColors[i] !== 'colors') {
									dataColor = dataColors[i];
								}

								if (variant.image !== null) {
									dataImg = "data-img='" + Utils.optimizeImage(variant.image, '300x') + " 300w'";
								}

								// if (variant.image !== null) {
								// 	dataImg = "data-img='" + Utils.optimizeImage(variant.image) + "'";
								// } else {
								// 	var _file = variant.option_color.toLowerCase().replace(/ /g, '-');
								// 	backgroundImage = boostPFSAppConfig.general.file_url.split('?')[0] + 'color-' + _file + '.png';
								// }

								var _file = variant.option_color.toLowerCase().replace(/ /g, '-');
								if (boostPFSThemeConfig.custom.swatch_color_display_type == 'swatch_color_display_type_image_color') {
									backgroundImage = boostPFSAppConfig.general.file_url.split('?')[0] + 'color-' + _file + '.png?v=' + boostPFSAppConfig.general.file_url.split('?')[1];
									backgroundImageURL = 'url(' + backgroundImage + ')';
								} else if (boostPFSThemeConfig.custom.swatch_color_display_type == 'swatch_color_display_type_image_product') {
									backgroundImage = Utils.optimizeImage(variant.image, '24x');
									backgroundImageURL = 'url(' + backgroundImage + ')';
								} else {
									backgroundImageURL = 'none';
								}
								colorSwatchesHtml += '<li>';
								colorSwatchesHtml += '<div class="tooltip">' + color + '</div>';
								colorSwatchesHtml += '<label style="background-color: ' + dataColor + '; background-image: '+ backgroundImageURL +';" ' + dataImg + '></label>';

								//colorSwatchesHtml += '<label style="' + border + 'background-image: url(' + Utils.optimizeImage(variant.image, '24x') + ');"' + if (variant.image !== null){ + 'data-img="' + Utils.optimizeImage(variant.image) + '"' + } '></label>';
								colorSwatchesHtml += '</li>';

							}
							var templist = colorlist + color + ' ';
							colorlist = templist;

							totalVariants++;

						}
					}
					// if (totalVariants == 1) {
					// colorSwatchesHtml = '<ul class="boost-pfs-filter-item-swatch">';
					// }
					if (totalVariants > 4) {
						colorSwatchesHtml += '<li class="boost-pfs-filter-item-swatch-more">';
						colorSwatchesHtml += '<a href="{{itemUrl}}" title="More Color">+' + (totalVariants - 4) + '</a>';
						colorSwatchesHtml += '</li>';
						totalVariants = 0;
					}
				}
			}
			colorSwatchesHtml += '</ul>';
		}
		return colorSwatchesHtml;
	}

	// Build Color Swatches
	function eventColorSwatches(event) {
		jQ('.boost-pfs-filter-item-swatch li label').each(function(){
			var img = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
          if(event == 'hover'){
			jQ(this).hover(function(){
				var newImage = jQ(this).data('img');
				img.attr('srcset', newImage);
			});
          }
          if(event == 'click'){
			jQ(this).click(function(){
				var newImage = jQ(this).data('img');
				img.attr('srcset', newImage);
			});
          }
		});
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}
		if (Settings.getSettingValue('general.paginationType') == 'default') {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}
			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					activeClass = '';
					if(paramSort == k) {
						activeClass = 'boost-pfs-filter-sort-item-active';
					}
					sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass+ '">' + sortingArr[k] + '</a></li>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function() {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';

    /* start-boost-custom */
    /* #boost-89846: Fix erro on console */
    var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
// 			var labelHandle = 'sorting_' + paramSort.replace(/\-/g, '_');
// 			labelSort = Labels[labelHandle];
          	labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}
    /* end-boost-custom */

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		var _this = this;
		jQ('.boost-pfs-filter-filter-dropdown a').click(function(e){
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).data('sort'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});

		jQ(".boost-pfs-filter-custom-sorting > button").click(function(){
			if (!jQ('.boost-pfs-filter-filter-dropdown').is(':animated')) {
				jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
				//jQ('.boost-pfs-filter-tree-v').hide();
			}
		});

		jQ(Selector.filterTreeMobileButton).click(function(){
			jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
		});
	};
	// For Toolbar - Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>' + boostPFSThemeConfig.label.toolbar_viewas + '</span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Build Show Limit
	ProductLimit.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {

			var numberList = Settings.getSettingValue('general.showLimitList');
			if (numberList != '') {
				// Build content
				var showLimitItemsHtml = '';
				var arr = numberList.split(',');
				for (var k in sortingArr) {
					showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
				}
				html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			}
		}
		return html;
	};
	// Build Breadcrumb
	Breadcrumb.prototype.compileTemplate = function (colData) {
		if (!colData) colData = this.collectionData;
		var breadcrumbItemsHtml = '';
		if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
			if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
				var colInfo = colData.collection;
				if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
					breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
				} else {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
				}
			} else {
				breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
			}
		}
		return breadcrumbItemsHtml
	};
	/************************** END BUILD TOOLBAR **************************/
	function matchHeightImage() {
		// jQ('.boost-pfs-filter-product-item-main-image').load(function() {
		// 	var imageContainer = jQ(this).parent();
		// 	imageContainer.css('width', '100%').css('height', jQ(this).height());
		// }).each(function() {
		// 	if (this.complete) jQ(this).load();
		// });
	}
	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {
      	if (!data) data = this.data;

		/** Start Swym integration **/
		window.SwymCallbacks = window.SwymCallbacks || [];
		window.SwymCallbacks.push(function(swat) {
		    // Wrap with callback for loading without additional checks
		    var products = [];
		    data.forEach(function(product) {
		        var image_src = Utils.getFeaturedImage(product.images_info);
		        var productCopy = product;
		        productCopy.featured_image = image_src;
		        productCopy.price = product.price_min; // Sometimes I need to multiply the price with 100
		        productCopy.compare_at_price = product.compare_at_price_min; // Sometimes I need to multiply the price with 100
		        products.push(productCopy);
		    });
		    swat.mapShopifyProducts(products); // Product mapped data to swym layer
		    swat.initializeActionButtons('.boost-pfs-filter-products'); // Buttons can now be initialized
		});
		/** End Swym integration **/

		if(boostPFSThemeConfig.custom.swatch_color_event_change_image != 'none'){
			eventColorSwatches(boostPFSThemeConfig.custom.swatch_color_event_change_image);
		}

		if (!data) data = this.data;

		// Intergrate Review Shopify
		if (window.SPR) {
			window.SPR.initDomEls();
			window.SPR.loadBadges();
		}

		if (Globals.queryParams.display !== 'list') equalHeight(data);
	};

	// Build additional elements
	Filter.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		var totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>';
		if (data.total_product == 1) {
			totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_one + '</span>';
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
		matchHeightImage();
		jQ(window).resize(function() {
			matchHeightImage();
		});

		jQ('body').find('.boost-pfs-filter-skeleton-button').remove();

		// Prevent double tap on iOS
		var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		if (isiOS){
			Utils.isMobile()&&jQ(".boost-pfs-filter-product-item").find("a").on("touchstart",function(){isScrolling=!1}).on("touchmove",function(){isScrolling=!0}).on("touchend",function(){isScrolling||(window.location=jQ(this).attr("href"))});
		}

		// Fix image not loaded on mobile
		//(Utils.isMobile()||null!=navigator.userAgent.match(/iPad/i))&&(setTimeout(function(){jQ(".boost-pfs-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},200),setTimeout(function(){jQ(".boost-pfs-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},2e3));

		// Build Image Swap
    swapImage(data);
	};

	Filter.prototype.isRender = function() {
        return this.isFetchedFilterData || this.isFetchedProductData;
  }
  var originalFilterRender = Filter.prototype.render;
  Filter.prototype.render = function() {
      if (this.isFetchedFilterData) {
         originalFilterRender.call(this);
      }
  }

	ProductListPlaceholder.prototype.render = function() {
		// Set limit number for product skeleton
		var placeholderLimit = this.settings.productsPerRow || this.settings.placeholderProductPerRow;
		// Build placeholder items
		var placeholderItem = this.compileTemplate();
		this.$element = [];
		for (var i = 0; i < placeholderLimit; i++) {
		  this.$element.push(jQ(placeholderItem));
		}
		// Show placeholder before send filter request OR hide it after get filter data
		if (!this.isFetchedProductData) {
		  this.setShow();
		} else {
		  this.setHide();
		}
	}

	ProductListPlaceholder.prototype.compileTemplateExtra = function() {
		var display = Globals.queryParams.display
		switch (display) {
			case 'list':
			//Todo: Build placeholder for List mode
			var template = boostPFSTemplate.productListPlaceholderHtml;
			var imgRatioSetting = parseFloat(this.settings.placeholderImageRatio);
			var imgRatio = imgRatioSetting > 0 ? imgRatioSetting : 1.4; // It mean w1:h1.4
			/**
			 * Set product class for product skeleton (to set column, style, etc.)
			 * - If had defined product_grid_class in boostPFSThemeConfig => use this config ELSE use our setting
			 */
			break;
		}
		return template
		.replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
		.replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
		.replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
		.replace(/{{paddingTop}}/g, imgRatio * 100)
	}

	/* Prevent conflict with theme vendor js */
	Array.prototype.insert = function(a, b) {}

/* Math qual Height */
	function equalHeight(data) {
		var equal_height = boostPFSFilterConfig.general.equal_height;

		if(equal_height != 'false'){
			var cropImagePosition = boostPFSFilterConfig.general.cropImagePossitionEqualHeight;

			var equal_i = -1;
	    var equal_els = [];
	    var equal_element = null;
	    var widthImage = jQ('.boost-pfs-filter-product-item').width();

	    var indexData = 0;


			// Equal Height Title
			jQ('.boost-pfs-filter-product-item').each(function(i, element) {

				var offsetTop = jQ(element).offset().top;
				if(!equal_element || equal_element.offset().top !== offsetTop) {
					equal_element = jQ(element);
					equal_i++;
				}

				if(!equal_els[equal_i]) {
					equal_els[equal_i] = [];
				}
				equal_els[equal_i].push(element);
			});


			// // For Auto
			// if(equal_height == 'auto'){

	  //     for(var i = 0; i < equal_els.length; i++) {
	  //       var max = 0;
	  //       var maxRatio = 0;
	  //       var iLength = equal_els[i].length;

	  //       for(var j = 0; j < equal_els[i].length; j++) {
	  //         var item = equal_els[i][j];
	  //         var height = jQ(item).find('.boost-pfs-filter-product-item-title').height();
	  //         max = Math.max(max, height);

	  //         indexData = (i * iLength) + j;
	  //         if (typeof(data[indexData]) != 'undefined') {
	  //           var images = data[indexData].images_info;
	  //           if(images.length > 0){
	  //             var ratioImage = images[0].height / images[0].width;
	  //             maxRatio = Math.max(maxRatio, ratioImage);
	  //         	}
	  //         }
	  //       }

	  //       jQ(equal_els[i]).find('.boost-pfs-filter-product-item-title').css({'min-height': max});

	  //       var maxHeightImage = widthImage * maxRatio;
	  //       jQ(equal_els[i]).find('.boost-pfs-filter-product-item-image-link').css({'padding-top': maxHeightImage}).addClass('boost-pfs-filter-crop-image-position-' + cropImagePosition);
	  //     }
	  //   }

	    // For Ratio
	    if(equal_height != 'false' && equal_height != 'auto'){
	      var heightImage = 0;
	      var widthImage = jQ('.boost-pfs-filter-product-item').width();
	      if(equal_height != 'false' && equal_height != 'auto'){
	        var ratioWidthHeight = boostPFSThemeConfig.custom.equal_height;
	      } else {
	        var ratioWidthHeight = '';
	      }

	      var ratioWidthHeightOther = boostPFSThemeConfig.custom.ratio_width_height_other;
	      if (ratioWidthHeightOther == '' &&  ratioWidthHeight == ''){
	        return null;
	      } else {
	        if (ratioWidthHeightOther == '') {
	          ratioWidthHeight = ratioWidthHeight.split(':');
	          ratioWidthHeight = parseInt(ratioWidthHeight[1]) / parseInt(ratioWidthHeight[0]);
	          heightImage = widthImage * ratioWidthHeight;
	        } else if (ratioWidthHeightOther != '')  {
	          ratioWidthHeightOther = ratioWidthHeightOther.split(':');
	          ratioWidthHeightOther = parseInt(ratioWidthHeightOther[1]) / parseInt(ratioWidthHeightOther[0]);
	          heightImage = widthImage * ratioWidthHeightOther;
	        }
	      }
	      jQ('.boost-pfs-filter-product-item-image-link').css({'padding-top': heightImage + 'px'}).addClass('boost-pfs-filter-crop-image-position-' + cropImagePosition);;

	    }
    }
  }

  // Swap Image

  function swapImage(data) {
    if (Utils.isMobile()) {

			$('.boost-pfs-filter-product-item-image-link').slick({
				dots: true,
				infinite: true,
				arrows: false,
				fade: true,
				speed: 300,
				slidesToShow: 1,
				slidesToScroll:1
			});
        // if (boostPFSThemeConfig.custom.active_image_swap) {
        //   var thumbUrl = Utils.getFeaturedImage(images, '260x');
				//
        //   jQ(".boost-pfs-filter-product-item").each(function(){
        //     var flipImageUrl = jQ(this).find('.boost-pfs-filter-product-item-main-image').data('img-flip');
        //     var flipImageSrcset= jQ(this).find('.boost-pfs-filter-product-item-main-image').data('img-flip-srcset');;
				//
        //     var html = '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
        //     'data-srcset="' + flipImageSrcset + '" ' +
        //     'data-src="' + flipImageUrl + '" ' +
    		//   	'data-widths="[270, 390, 540, 720]" ' +
        //     'data-sizes="auto" ' +
        //     'src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" ' +
        //     'alt="' + data.title + '" />';
				//
        //     jQ(this).find('.boost-pfs-filter-product-item-image-link').prepend(html);
				//
				//
        //   });
				//
        // }
      }
  }

})();
